import { useEffect } from 'react';

interface Shortcut {
  key: string;
  action: () => void;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  altKey?: boolean;
}

const Shortcuts = (shortcuts: Shortcut[]) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {

      if(event.key === 'Tab') return;

      //if event key is space or enter and document.activeElement has data-componentname attribute
      if((event.key === ' ' || event.key === 'Enter') && document.activeElement && document.activeElement.hasAttribute('data-componentname')) {
        event.preventDefault();
        let element = document.activeElement as HTMLDivElement;
        let button: HTMLButtonElement | null = element.querySelector('button');
        if(button instanceof HTMLButtonElement) {
          button.click();
          return;
        }
      }

      const shortcut = shortcuts.find(
        (shortcut) =>
          shortcut.key === event.key &&
          (shortcut.ctrlKey ? event.ctrlKey : true) &&
          (shortcut.shiftKey ? event.shiftKey : true) &&
          (shortcut.altKey ? event.altKey : true),
      );

      if (shortcut) {
        event.preventDefault();
        shortcut.action();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [shortcuts]);
};

export default Shortcuts;
